module.exports = __webpack_public_path__ + "assets/img/verify-code-group_new.d914e0a7.png";